



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Assets from '@/constants/assets.ts';
import Datepicker, { DatepickerBorder } from '@/shared/components/datepicker/index.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import UtilsService from '@/core/services/utils.service';
import { Expense, Income } from '@/manager/sync/operation.model';

import dayjs from 'dayjs';

@Component({
    components: {
        Datepicker,
        TopModal,
        FieldSet,
    },
    computed: {
        ...mapGetters ({
            kpiList: 'getKpiList',
        }),
    },
})
export default class KPIModal extends Vue {
    @Prop() private opened!: boolean;
    @Prop() private dateFrom!: string;
    @Prop() private dateTo!: string;

    private assets = Assets;
    private utilsService = UtilsService;
    private kpiList!: any;
    private localFrom: string = '';
    private localTo: string = '';
    private datepickerBorder = DatepickerBorder;
    private limitDate = dayjs(this.requestedDateTo, { locale: 'es' }).add(1, 'day').toISOString();

    @Watch('opened')
    private watchOpened(newVal: boolean, oldVal: boolean) {
        if ( newVal ) {
            this.fetchKpiList();
        }
    }

    private created() {
        this.fetchKpiList();
    }

    get incomeKpiList() {
        let list = [];
        if ( this.kpiList.operations ) {
            list = this.kpiList.operations.filter(
                (kpi: any) => kpi.operationType === Income,
            );
        }
        return list;
    }

    get expenseKpiList() {
        let list = [];
        if ( this.kpiList.operations ) {
            list = this.kpiList.operations.filter(
                (kpi: any) => kpi.operationType === Expense,
            );
        }
        return list;
    }

    get requestedDateFrom() {
        let date = this.dateFrom;
        if (this.localFrom) {
            date = this.localFrom;
        }
        return date;
    }

    get requestedDateTo() {
        let date = this.dateTo;
        if (this.localTo) {
            date = this.localTo;
        }
        return date;
    }

    private closeModal() {
        if ( this.opened ) {
            this.localFrom = '';
            this.localTo = '';
            this.$emit('close-modal-kpi', false);
        }
    }

    private isEmptyRow(row: any) {
        let empty = false;
        if ( row.percentage === 0) {
            empty = true;
        }
        return empty;
    }

    private fetchKpiList(callback: any = () => { const doNothing = 1; }) {
        const from = this.requestedDateFrom;
        const to = this.requestedDateTo;

        this.$store.dispatch(
            'fetchKpiList',
            {
                from,
                to,
            },
        );
    }

    private dateRangeSelected(from: any, to: any) {
        this.localFrom = from;
        this.localTo = to;
        this.fetchKpiList();
    }

}
